<template>
  <div class="zwy-login">
    <div class="top-logo">
      <img class="zwy-logo" src="~assets/images/login/zwy-login-logo.png">
    </div>
    <div class="zwy-login-content">
      <el-form
        ref="zwyLoginForm"
        :model="zwyLoginForm"
        :rules="loginRules"
        class="login-form"
        auto-complete="on"
        label-position="left"
      >
        <p class="zwy-login-title">欢迎登录</p>
        <p class="zwy-login-sub-title">水晶后台管理系统</p>
        <el-form-item prop="username">
          <img class="zwy-login-user" src="~assets/images/login/zwy-login-user.png">
          <el-input
            ref="username"
            v-model="zwyLoginForm.username"
            type="text"
            placeholder="请输入用户名"
          />
        </el-form-item>
        <el-form-item prop="password">
          <img class="zwy-login-psw" src="~assets//images/login/zwy-login-psw.png">
          <el-input
            ref="password"
            v-model="zwyLoginForm.password"
            @keyup.enter.native="zwyLogin('zwyLoginForm')"
            type="password"
            placeholder="请输入密码"
          />
        </el-form-item>
        <el-button
          type="primary"
          class="zwy-login-btn"
          @click.native.prevent="zwyLogin('zwyLoginForm')"
          >登录</el-button
        >
      </el-form>
    </div>
  </div>
</template>

<script>
import { saveToken, saveDBUserRealName, deleteToken } from "common/js/storage";
import User from "models/user";
const user = new User();
export default {
  data() {
    const validateUsername = (rule, value, callback) => {
      if (!value) {
        callback(new Error("请输入用户名"));
      } else {
        callback();
      }
    };
    const validatePassword = (rule, value, callback) => {
      if (!value) {
        callback(new Error("请输入密码"));
      } else {
        callback();
      }
    };
    return {
      zwyLoginForm: {
        username: "",
        password: "",
      },
      loginRules: {
        username: [
          { required: true, trigger: "blur", validator: validateUsername },
        ],
        password: [
          { required: true, trigger: "blur", validator: validatePassword }
        ],
      },
    }
  },

  created() {
  },

  methods: {
    zwyLogin(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let username = this.zwyLoginForm.username
          let password = this.zwyLoginForm.password
          let data = {
            username,
            password
          };
          user.postUserLogin(data).then(res => {
            if (res.success) {
              deleteToken()
              saveToken(res.result.token);
              saveDBUserRealName(res.result.username);
              this.$router.replace("/home");
            } else {
              this.$message.error(res.message)
            }
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    }
  }
}
</script>

<style lang='scss'>
.zwy-login {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;

  .top-logo {
    height: 78px;
    padding-left: 40px;
    display: flex;
    justify-content: flex-start;
    align-items: center;

    .zwy-logo {
      width: 135px;
      height: 48px;
    }
  }

  .zwy-login-content {
    flex: 1;
    background: url('../../../assets/images/login/6.png');
    background-size: 100% 100%;
    background-repeat: no-repeat;
    display: flex;
    justify-content: flex-end;
    align-items: center;

    .el-form {
      width: 340px;
      height: 342px;
      margin-right: 100px;
      background: white;
      border-radius: 8px;
      padding: 44px 20px 40px 20px;
      box-sizing: border-box;
      margin-top: -62px;

      .zwy-login-title {
        line-height: 45px;
        font-size: 32px;
        font-family: 'PingFang SC-Heavy';
        font-weight: 800;
        color: #333;
        text-align: left;
        margin-bottom: 4px;
      }

      .zwy-login-sub-title {
        font-size: 24px;
        font-family: 'PingFang SC-Heavy';
        font-weight: 800;
        color: #333;
        line-height: 33px;
        text-align: left;
        margin-bottom: 20px;
      }

      .el-form-item {
        margin-bottom: 20px;

        .el-form-item__content {
          display: flex;
          position: relative;

          .el-input,
          .el-input__inner {
            line-height: 32px;
          }

          .el-input.is-active .el-input__inner,
          .el-input__inner:focus {
            background: white;
          }

          .el-input__inner {
            padding-left: 28px;
            border-radius: 3px;
            font-size: 14px;
            font-weight: 400;
            font-family: 'PingFang SC-Regular';
          }

          .zwy-login-user,
          .zwy-login-psw {
            position: absolute;
            z-index: 10;
            width: 16px;
            height: 16px;
            top: 11px;
            left: 6px;
          }
        }
      }

      .zwy-login-btn {
        width: 100%;
        border-radius: 3px;
        margin-top: 20px;
        padding-top: 9px;
        padding-bottom: 9px;
        border: none;
        background-color: #2E68EA!important;
        color: white!important;
      }
    }
  }

  // 取消选中背景色
  input:-internal-autofill-previewed,
  input:-internal-autofill-selected {
    transition: background-color 5000s ease-in-out 0s !important;
  }
}
</style>
